export class BulkQuery {
    name: string;
    hasError: boolean;
    errorText: string;
    isWarning: boolean;
    hoverIcon?: boolean;

    constructor(value?: Partial<BulkQuery>) {
        if (value) {
            Object.assign(this, value);
        }
    }
}
